<template>
  <v-slide-y-transition mode="out-in">
    <v-container class="fill-height pa-0 mt-0 chat-drawer-container fluid">      
      <template v-if="!$vuetify.breakpoint.smAndDown">
        <v-layout row>
          <v-flex lg3 class="chat-contact--sidebar white">
            <chat-contact-list></chat-contact-list>
          </v-flex>
          <v-flex lg9 v-if="showWindow">
            <chat-contact-profile></chat-contact-profile>
          </v-flex>
        </v-layout>
      </template>
      <template v-else>
        <v-layout column>
          <v-flex sm12 class="white" v-if="showSidebar">
            <chat-contact-list></chat-contact-list>
          </v-flex>
          <v-flex sm12 v-if="showWindow">
            <chat-contact-profile></chat-contact-profile>
          </v-flex>
        </v-layout>        
      </template>
    </v-container>
  </v-slide-y-transition>  
</template>
<script>
import ChatContactList    from './ContactList';
import ChatContactProfile from './ContactProfile';

var _  = require('lodash');

export default {
  components: {
    ChatContactList,
    ChatContactProfile
  },
  data () {
    return {
      chat: null,
      selectedTab: null,
    };
  },
  computed: {
    showSidebar () {
      return this.$route.query.id === undefined;
    },
    showWindow () {
      return this.$route.query.id !== undefined;
    },    
  },
};
</script>

